import { environment } from '../environments/environment';

export const DEBUG_INFO_ENABLED: boolean = !environment.production;
export const SERVER_API_URL = environment.serverApiUrl;
export const KAFKA_URL = environment.kafkaUrl;
